module.exports = __webpack_public_path__ + "static/media/w (38).cbed26e1.jpg";